import { clearPendingWithdrawals } from './withdrawalRequests';

const TOKEN_KEY = 'crowd_token';
const EMAIL_KEY = 'crowd_email';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  if (getToken() !== token) clearPendingWithdrawals();
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
  clearPendingWithdrawals();
}

export function getEmail() {
  return localStorage.getItem(EMAIL_KEY) || '';
}

export function setEmail(email) {
  localStorage.setItem(EMAIL_KEY, email);
}
